import { FC } from 'react';
import { Modal } from 'antd';
import PureVideo, { PureVideoProps } from '@base/lib/PureVideo';
import Image from '@base/lib/ThemeImage';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';
import Tracker from '@base/lib/Tracker';
import { ITrackElementData } from 'base/utils/tracker';
import { getPlaceholderPercentage } from 'base/utils/dom-size';
import cn from 'classnames';

export type IMediaPopupProps = {
    visible: boolean;
    onCancel: () => void;
    width: number;
    height: number;
    maskOpacity?: number; // 蒙板透明度, 0-100
    iframe?: {
        src: string;
    },
    image?: {
        src: string;
        href?: string;
    };
    video?: {
        src: string | string[];
        poster?: string;
        autoPlay?: boolean;
        muted?: boolean;
    };
    trackData?: ITrackElementData;//打点
};

export const MediaPopupMain: FC<IMediaPopupProps> = props => {
    const {
        width,
        height,
        iframe,
        image,
        video,
        onCancel,
    } = props;

    if (iframe) {
        return (
            <div
                className={'relative'}
                style={{
                    width: width,
                    maxWidth: '100%',
                    paddingBottom: `${(height * 100 / width) || 60}%`,
                }}
            >
                <div className={cn(styles['iframe-wrap'], 'absolute')}>
                    <iframe
                        className={cn(styles['iframe'])}
                        width={width || 1200}
                        height={height || 675}
                        src={iframe.src}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        )
    }

    if (image) {
        return (
            <Image
                {...image}
                onClick={() => {
                    onCancel() // 跳转关闭
                }}
                width={width}
                height={height}
                background={false}
            />
        )
    }

    return (
        <div
            className="sw-placeholder"
            style={{
                paddingBottom: getPlaceholderPercentage(width, height)
            }}
        >
            <PureVideo
                {...video as PureVideoProps}
                controls
                absolute
            />
        </div>
    )
};

export const MediaPopup: FC<IMediaPopupProps> = props => {
    const {
        visible,
        onCancel,
        width,
        maskOpacity = 30,
        iframe,
        image,
        video,
        trackData,
    } = props;

    return !iframe && !image && !video ? null : (
        <Modal
            className={styles['media-popup']}
            open={visible}
            width={width}
            onCancel={onCancel}
            footer={false}
            centered
            destroyOnClose
            closeIcon={<Iconfont className={'icon-x'}/>}
            maskStyle={{
                backgroundColor: `rgba(0, 0, 0, ${maskOpacity / 100})`
            }}
        >
            {trackData
                ? (
                    <Tracker async data={trackData}>
                        <div>
                            <MediaPopupMain {...props}/>
                        </div>
                    </Tracker>
                )
                : <MediaPopupMain {...props}/>
            }
        </Modal>
    );
};